import { UserList } from '@features/users';

export function UsersPage() {
  return <UserList />;
}
